import ApplePay from './views/apple-pay.c';
export default ApplePay;
